import React from 'react'
import SideBar from '../components/SideBar'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import DetailsTopBar from '../components/DetailsTopBar'
import { useLocation, useNavigate } from 'react-router-dom';
import AgentRequestForm from '../components/AgentRequestForm';

function RequestDetails() {
   const location = useLocation();
    const agent = location.state?.agent;
    const navigate = useNavigate();

     /// Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/agent-invite-history",
    },
    {
      key: "request",
      label: "Promote / Demote",
      path: "/agent-promotion",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);

    if (!agent) {
        return (
            <div className="member-details-layout">
                <SideBar />
                <div className="member-details-main">
                    <p style={{ padding: "30px" }}>No agent data available.</p>
                </div>
            </div>
        );
    }

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
            title="Retail Business Agent Details"
            subtitle="You can promote or demote the agent's role"
            breadcrumbs={[
                {label: "Home", path: "/dashboard"},
                {label: "Manage Retail Business Agent", path: "/manage-agent"},
                {label: "Promote / Demote", path: "/agent-promotion"},
            ]}
        />
        <DetailsTopBar
            tabs={tabs}
            activeTab="request"
            agent={agent}
        />
        <AgentRequestForm agent={agent} />
      </div>
    </div>
  )
}

export default RequestDetails